import React, { Component } from 'react';
import { connect } from 'react-redux';
import { onRecover } from '../actions/EpikBoxes';
import WithUserData from '../HOC/withUserData';
import './Licenses.css';

class Licenses extends Component {
  constructor(props) {
    super(props);
    this.token = localStorage.getItem('jwtToken') || null;
  }
  render() {
    return (
      <div>
        <div className="license-section">
          <h1 class="tape">
            <span>LICENSES COMING SOON...</span>
          </h1>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.AppState.user,
  };
};

const mapDispatchToProps = dispatch => ({
  onRecover: (token, id) => dispatch(onRecover(token, id)),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(WithUserData(Licenses));
